import React from 'react';
import AVAChatbot from '../avaChatbot/AVAChatbot';

function HomePage() {
  return (
    <div   style={{
      position: 'fixed',
      bottom: '0',
      right: '0',
      margin: '24px', // optional, to give some space from the edges
      zIndex: '1000', // ensures it stays above other content if needed
    }}>
      <AVAChatbot/>
    </div>
  );
}

export default HomePage;